export default {
  getNavbarTitle: (state) => state.navbarTitle,
}